import { render, staticRenderFns } from "./LearnerIndividualCourseCertificatePage.vue?vue&type=template&id=00128776&scoped=true"
import script from "./LearnerIndividualCourseCertificatePage.vue?vue&type=script&lang=js"
export * from "./LearnerIndividualCourseCertificatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00128776",
  null
  
)

export default component.exports